<admin-header [primaryButtons]="headerPrimaryButtons" [tertiaryButtons]="headerTertiaryButtons" [title]="title"></admin-header>

<div class="bp-toolbar">
	<span class="bp-legend"><span class="swatch in"></span> Editable input</span>
	<span class="bp-legend"><span class="swatch calc"></span> Calculated</span>
	<span class="bp-legend"><span class="swatch out"></span> Planning output</span>
	<dx-button text="Reset to sample" icon="fal fa-undo" stylingMode="outlined" (onClick)="resetToDefaults()" style="margin-left:auto"></dx-button>
</div>

<div class="bp-grid">

	<!-- ===================== INPUT COLUMN ===================== -->
	<div class="bp-col">

		<section class="bp-card">
			<h3 class="bp-card-title">Tool &amp; schedule inputs</h3>
			<div class="bp-rows">
				<div class="bp-row">
					<label>Project / tool</label>
					<dx-text-box class="in" [(value)]="projectName" valueChangeEvent="keyup"></dx-text-box>
					<span class="unit"></span>
				</div>
				<div class="bp-row">
					<label>Material</label>
					<dx-select-box class="in" [(value)]="materialType" [items]="materialOptions" displayExpr="name" valueExpr="id" placeholder="Select a material…" [showClearButton]="true" (onValueChanged)="materialChanged()"></dx-select-box>
					<span class="unit"></span>
				</div>
				<div class="bp-row">
					<label>Material density <i class="fal fa-info-circle" title="Auto-filled from the material. Override with the certificate value where available."></i></label>
					<dx-number-box class="in" [(value)]="inputs.densityKgM3" [min]="0" [showSpinButtons]="false" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">kg/m³</span>
				</div>
				<div class="bp-row">
					<label>Blank length</label>
					<dx-number-box class="in" [(value)]="inputs.lengthMm" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">mm</span>
				</div>
				<div class="bp-row">
					<label>Blank width</label>
					<dx-number-box class="in" [(value)]="inputs.widthMm" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">mm</span>
				</div>
				<div class="bp-row">
					<label>Blank height</label>
					<dx-number-box class="in" [(value)]="inputs.heightMm" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">mm</span>
				</div>
				<div class="bp-row">
					<label>Manual mass override <i class="fal fa-info-circle" title="Enter 0 to use L × W × H. Use an override for a non-rectangular or pre-profiled block."></i></label>
					<dx-number-box class="in" [(value)]="inputs.manualMassOverrideKg" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">kg</span>
				</div>
				<div class="bp-row">
					<label>Finished tool-body mass</label>
					<dx-number-box class="in" [(value)]="inputs.finishedMassKg" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">kg</span>
				</div>
				<div class="bp-row">
					<label>Other CNC / inspection hours</label>
					<dx-number-box class="in" [(value)]="inputs.otherCncHrs" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">hrs</span>
				</div>
				<div class="bp-row">
					<label>Schedule contingency</label>
					<dx-number-box class="in" [(value)]="inputs.contingencyPct" [min]="0" [max]="2" [step]="0.05" format="#0%" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">%</span>
				</div>
				<div class="bp-row">
					<label>Productive hours per shift</label>
					<dx-number-box class="in" [(value)]="inputs.hoursPerShift" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">hrs</span>
				</div>
				<div class="bp-row">
					<label>Shifts per working day</label>
					<dx-number-box class="in" [(value)]="inputs.shiftsPerDay" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">count</span>
				</div>
			</div>
		</section>

		<section class="bp-card">
			<h3 class="bp-card-title">Roughing</h3>

			<div class="bp-stage" *ngFor="let s of roughStages; let i = index">
				<div class="bp-stage-head">
					<span class="bp-stage-name">Stage {{ i + 1 }} · {{ i === 0 ? 'primary' : 'secondary' }}</span>
				</div>
				<div class="bp-rows">
					<div class="bp-row">
						<label>Share of removal</label>
						<dx-number-box class="in" [(value)]="s.share" [min]="0" [max]="1" [step]="0.05" format="#0%" (onValueChanged)="syncRoughing()"></dx-number-box>
						<span class="unit">%</span>
					</div>
					<div class="bp-row">
						<label>Rate input</label>
						<span class="seg-toggle">
							<button [class.active]="s.rateMode === 'mrr'" (click)="setStageMode(s, 'mrr')">MRR</button>
							<button [class.active]="s.rateMode === 'feed'" (click)="setStageMode(s, 'feed')">Feed &amp; cut</button>
						</span>
						<span class="unit"></span>
					</div>
					<div class="bp-row" *ngIf="s.rateMode === 'mrr'">
						<label>Base MRR</label>
						<dx-number-box class="in" [(value)]="s.mrr" [min]="0" (onValueChanged)="syncRoughing()"></dx-number-box>
						<span class="unit">cm³/min</span>
					</div>
					<ng-container *ngIf="s.rateMode === 'feed'">
						<div class="bp-row">
							<label>Feedrate</label>
							<dx-number-box class="in" [(value)]="s.feed" [min]="0" (onValueChanged)="syncRoughing()"></dx-number-box>
							<span class="unit">mm/min</span>
						</div>
						<div class="bp-row">
							<label>Axial depth of cut <span class="dim">(ap)</span></label>
							<dx-number-box class="in" [(value)]="s.ap" [min]="0" [step]="0.5" (onValueChanged)="syncRoughing()"></dx-number-box>
							<span class="unit">mm</span>
						</div>
						<div class="bp-row">
							<label>Radial width of cut <span class="dim">(ae)</span></label>
							<dx-number-box class="in" [(value)]="s.ae" [min]="0" [step]="1" (onValueChanged)="syncRoughing()"></dx-number-box>
							<span class="unit">mm</span>
						</div>
						<div class="bp-row calc">
							<label>Base MRR <span class="dim">from feed</span></label>
							<span class="calc-val">{{ s.mrr | number:'1.0-1' }}</span>
							<span class="unit">cm³/min</span>
						</div>
					</ng-container>
					<div class="bp-row">
						<label>Effective process factor <i class="fal fa-info-circle" title="Fraction of the theoretical ap × ae × feed rate actually achieved in cut. ~100% for open primary roughing; much lower for small-cutter rest-rough in tight areas (retracts, repositioning, partial engagement) — set it to match your CAM / real hours."></i></label>
						<dx-number-box class="in" [(value)]="s.factor" [min]="0.05" [max]="1" [step]="0.05" format="#0%" (onValueChanged)="syncRoughing()"></dx-number-box>
						<span class="unit">%</span>
					</div>
					<div class="bp-row">
						<label>Fixed setup / prove-out</label>
						<dx-number-box class="in" [(value)]="s.fixedHrs" [min]="0" (onValueChanged)="syncRoughing()"></dx-number-box>
						<span class="unit">hrs</span>
					</div>
					<div class="bp-row calc">
						<label>Effective MRR</label>
						<span class="calc-val">{{ result.roughingStages[i]?.effectiveMrrCm3Min | number:'1.0-1' }}</span>
						<span class="unit">cm³/min</span>
					</div>
					<div class="bp-row calc">
						<label>Removal volume</label>
						<span class="calc-val">{{ result.roughingStages[i]?.removalVolumeCm3 | number:'1.0-0' }}</span>
						<span class="unit">cm³</span>
					</div>
					<div class="bp-row calc">
						<label>Cut hours</label>
						<span class="calc-val">{{ result.roughingStages[i]?.cutHrs | number:'1.0-1' }}</span>
						<span class="unit">hrs</span>
					</div>
					<div class="bp-row calc strong">
						<label>Stage total hours</label>
						<span class="calc-val">{{ result.roughingStages[i]?.totalHrs | number:'1.0-1' }}</span>
						<span class="unit">hrs</span>
					</div>
				</div>
			</div>

			<div class="bp-rows bp-roughing-summary">
				<div class="bp-row">
					<label>Combined share of removal <i class="fal fa-info-circle" title="Sum of the roughing stages' shares. Keep at or below 100% — the remainder is the finishing stock."></i></label>
					<span class="calc-val plain-val" [class.over]="combinedShare > 1.0001">{{ combinedShare | percent:'1.0-0' }}</span>
					<span class="unit"></span>
				</div>
				<div class="bp-row calc strong">
					<label>Roughing total <span class="dim" *ngIf="roughStages.length > 1">all stages</span></label>
					<span class="calc-val">{{ result.roughingTotalHrs | number:'1.0-1' }}</span>
					<span class="unit">hrs</span>
				</div>
			</div>
		</section>

		<section class="bp-card">
			<h3 class="bp-card-title">Finishing</h3>
			<div class="bp-rows">
				<div class="bp-row">
					<label>Finish surface area</label>
					<dx-number-box class="in" [(value)]="finishAreaInput" [min]="0" (onValueChanged)="areaChanged()"></dx-number-box>
					<span class="unit seg-toggle sm">
						<button [class.active]="areaUnit === 'm2'" (click)="setAreaUnit('m2')">m²</button>
						<button [class.active]="areaUnit === 'mm2'" (click)="setAreaUnit('mm2')">mm²</button>
					</span>
				</div>
				<div class="bp-row">
					<label>Toolpath stepover</label>
					<dx-number-box class="in" [(value)]="inputs.stepoverMm" [min]="0.01" [step]="0.1" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">mm</span>
				</div>
				<div class="bp-row">
					<label>Finish feedrate</label>
					<dx-number-box class="in" [(value)]="inputs.finishFeedMmMin" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">mm/min</span>
				</div>
				<div class="bp-row">
					<label>Finish passes</label>
					<dx-number-box class="in" [(value)]="inputs.finishPasses" [min]="0" [step]="1" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">count</span>
				</div>
				<div class="bp-row">
					<label>Effective process factor <i class="fal fa-info-circle" title="Fraction of the programmed feed actually achieved in cut (acceleration, 3D form, retracts). Calibrate to your CAM machining time — the effective feed usually sits a little under the average."></i></label>
					<dx-number-box class="in" [(value)]="inputs.finishingFactor" [min]="0.05" [max]="1" [step]="0.05" format="#0%" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">%</span>
				</div>
				<div class="bp-row">
					<label>Fixed setup / prove-out</label>
					<dx-number-box class="in" [(value)]="inputs.finishingFixedHrs" [min]="0" (onValueChanged)="recompute()"></dx-number-box>
					<span class="unit">hrs</span>
				</div>
				<div class="bp-row calc">
					<label>Effective feed</label>
					<span class="calc-val">{{ result.effectiveFinishFeedMmMin | number:'1.0-0' }}</span>
					<span class="unit">mm/min</span>
				</div>
				<div class="bp-row calc">
					<label>Finish toolpath length</label>
					<span class="calc-val">{{ result.finishToolpathLengthM | number:'1.0-1' }}</span>
					<span class="unit">m</span>
				</div>
				<div class="bp-row calc">
					<label>Finishing cut hours</label>
					<span class="calc-val">{{ result.finishingCutHrs | number:'1.0-1' }}</span>
					<span class="unit">hrs</span>
				</div>
				<div class="bp-row calc strong">
					<label>Finishing total hours</label>
					<span class="calc-val">{{ result.finishingTotalHrs | number:'1.0-1' }}</span>
					<span class="unit">hrs</span>
				</div>
			</div>
		</section>

		<section class="bp-card">
			<h3 class="bp-card-title">Stock calculations</h3>
			<div class="bp-rows">
				<div class="bp-row calc">
					<label>Calculated rectangular mass</label>
					<span class="calc-val">{{ result.rectangularMassKg | number:'1.0-1' }}</span>
					<span class="unit">kg</span>
				</div>
				<div class="bp-row calc">
					<label>Starting mass used</label>
					<span class="calc-val">{{ result.startingMassKg | number:'1.0-1' }}</span>
					<span class="unit">kg</span>
				</div>
				<div class="bp-row calc">
					<label>Mass removed</label>
					<span class="calc-val">{{ result.massRemovedKg | number:'1.0-1' }}</span>
					<span class="unit">kg</span>
				</div>
				<div class="bp-row calc">
					<label>Removal volume</label>
					<span class="calc-val">{{ result.removalVolumeCm3 | number:'1.0-0' }}</span>
					<span class="unit">cm³</span>
				</div>
				<div class="bp-row calc">
					<label>Material removal</label>
					<span class="calc-val">{{ result.materialRemovalPct | percent:'1.0-1' }}</span>
					<span class="unit"></span>
				</div>
				<div class="bp-row calc">
					<label>Buy-to-fly ratio</label>
					<span class="calc-val">{{ result.buyToFlyRatio | number:'1.0-2' }}</span>
					<span class="unit">: 1</span>
				</div>
			</div>
		</section>

	</div>

	<!-- ===================== SUMMARY COLUMN ===================== -->
	<div class="bp-col bp-summary-col">

		<section class="bp-card bp-summary">
			<h3 class="bp-card-title">Production planning summary</h3>
			<div class="bp-headline">
				<div class="bp-headline-main">
					<span class="bp-headline-num">{{ result.plannedOccupancyHrs | number:'1.0-1' }}</span>
					<span class="bp-headline-lbl">planned machine hours</span>
				</div>
				<div class="bp-headline-side">
					<div><b>{{ result.equivalentShifts | number:'1.0-1' }}</b><span>shifts</span></div>
					<div><b>{{ result.equivalentWorkingDays | number:'1.0-1' }}</b><span>working days</span></div>
				</div>
			</div>

			<table class="bp-breakdown">
				<thead><tr><th>Stage</th><th>Hours</th><th>% of planned</th></tr></thead>
				<tbody>
					<tr *ngFor="let b of result.breakdown">
						<td>{{ b.stage }}</td>
						<td class="num">{{ b.hours | number:'1.0-1' }}</td>
						<td class="pct">
							<div class="bar-wrap"><div class="bar" [style.width.%]="b.pctOfPlanned * 100"></div></div>
							<span>{{ b.pctOfPlanned | percent:'1.0-0' }}</span>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr><td>Base CNC hours</td><td class="num">{{ result.baseCncHrs | number:'1.0-1' }}</td><td></td></tr>
					<tr class="planned"><td>Planned occupancy</td><td class="num">{{ result.plannedOccupancyHrs | number:'1.0-1' }}</td><td></td></tr>
				</tfoot>
			</table>
		</section>

		<section class="bp-card bp-note">
			<h3 class="bp-card-title">Estimating method</h3>
			<p>Losses are counted <b>once</b>. Each stage uses a single <b>effective process factor</b> for in-cut losses (retracts, rapids, engagement, tool changes, measurement) instead of stacking a separate efficiency and allowance — which overlapped and over-estimated. Fixed setup and schedule contingency stay as separate, visible layers.</p>
			<p class="muted">Each roughing stage has an <b>effective process factor</b> — the share of the theoretical ap × ae × feed rate actually achieved in cut. Open primary roughing is ~100%; small-cutter rest-rough in tight areas is much lower (retracts, repositioning, partial engagement) — set it to match your CAM / real hours. Finishing has the same factor; its effective feed usually sits a touch under the programmed average, so calibrate it to your CAM machining time. Fixed setup / prove-out is a separate on-machine line — CAM cut times don't include it, so add it only where you budget it.</p>
		</section>

		<section class="bp-card">
			<h3 class="bp-card-title">MRR &amp; feed library</h3>
			<p class="muted small">Starting placeholders — apply one, then refine from your own machine history.</p>
			<table class="bp-library">
				<thead><tr><th>Use case</th><th>Rate</th><th></th></tr></thead>
				<tbody>
					<tr *ngFor="let e of mrrLibrary">
						<td><b>{{ e.useCase }}</b><span class="muted small">{{ e.strategy }}</span></td>
						<td class="num" *ngIf="e.roughMrrStart">{{ e.roughMrrStart }} <span class="muted small">cm³/min</span></td>
						<td class="num" *ngIf="e.finishFeedStart">{{ e.finishFeedStart }} <span class="muted small">mm/min</span></td>
						<td class="apply">
							<dx-button *ngIf="e.roughMrrStart" text="Use" stylingMode="text" (onClick)="applyRoughingPreset(e)"></dx-button>
							<dx-button *ngIf="e.finishFeedStart" text="Use" stylingMode="text" (onClick)="applyFinishingPreset(e)"></dx-button>
						</td>
					</tr>
				</tbody>
			</table>
		</section>

	</div>
</div>
